// extracted by mini-css-extract-plugin
export default {"nextPaymentAmount":"nextPaymentAmount"};